import { Injectable, signal } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { interval } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class UptimeClockService {
  private readonly _tick = signal(0);

  public readonly tick = this._tick.asReadonly();

  constructor() {
    interval(1000)
      .pipe(takeUntilDestroyed())
      .subscribe(() => {
        this._tick.update((value) => value + 1);
      });
  }
}
